class RcsUtils {
  static applyLazyLoad() {
    return new LazyLoad({
      elements_selector: '.lazy',
      data_src: 'original'
    });
  }

  static triggerEvent(nameEvent, element, params = {}) {
    let event;
    if (window.CustomEvent) {
      event = new CustomEvent(nameEvent, {
        detail: params
      });
    } else {
      event = document.createEvent('CustomEvent');
      event.initCustomEvent(nameEvent, true, true, params);
    }
    element.dispatchEvent(event);
  }

  static addClass(element, className) {
    if (element !== null) {
      if (element.classList) {
        element.classList.add(className);
      } else {
        element.className += ' ' + className;
      }
    }
  }

  static removeClass(element, className) {
    if (element !== null) {
      if (element.classList) {
        element.classList.remove(className);
      } else {
        element.className = element.className.replace(
          new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'),
          ' '
        );
      }
    }
  }

  static hasClass(element, className) {
    let hasClass = false;

    if (element !== null) {
      if (element.classList) {
        hasClass = element.classList.contains(className);
      } else {
        hasClass = new RegExp('(^| )' + className + '( |$)', 'gi').test(
          element.className
        );
      }
    }

    return hasClass;
  }

  static getDevice() {
    let device = 'desktop';

    if (document.querySelector('html.mobile') !== null) {
      device = 'mobile';
    }

    return device;
  }
}

module.exports = RcsUtils;



// WEBPACK FOOTER //
// ./src/rcs_cor_hp-lazy-loading/utils/RcsUtils.js